import { getObservableById, setObservableById } from './helper';

export const TableSettingsSubject$ = new Map();

export const getTableSettings$ = (compId: string) =>
  getObservableById(TableSettingsSubject$, compId, []);
export const setTableSettings$ = (tableSettings: any, compId: string) =>
  setObservableById(TableSettingsSubject$, tableSettings, compId);
